import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetItemCategory  {
    _originalTypeClassName = "zERP.BO.BudgetItemCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetItemCategory.translate = translateService;
}
this.Items = [];
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.IsExpense = false;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
IsExpense:any;
FullName:any;
Items:any;
Entity:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.BudgetItemCategory.removeItems($this, $this.Items[0]);
                }

                Domain.BudgetItemCategory.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetItemCategory.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
if (item.Category != $this) {
Domain.BudgetItem.setCategory(item, $this);
}
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetItemCategory.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
item.Category = null;
}
static clearItems = ($this) => { $this.Items = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}

static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}
static SetBudgetItemLevels(items: any,parent: any,level: any): any{if (CLMS.Framework.Number.GreaterThan(() => level, () => 10)) {throw Error("Too deep categories. Probably recursion");}
for (let _iitem = 0; _iitem < (items?.linq?.where((c) => c?.Parent == parent)?.toArray() == null ? 0 : items?.linq?.where((c) => c?.Parent == parent)?.toArray().length); _iitem++) {let item = items?.linq?.where((c) => c?.Parent == parent)?.toArray()[_iitem];item.Level = level;item.IsTermninal = !(items?.linq?.any((i) => i?.Parent == item));Domain.BudgetItemCategory.SetBudgetItemLevels(items, item, Joove.Common.safeNumber(level) + Joove.Common.safeNumber(1));}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}